export default function formatReadingDuration(
  seconds: number | null | undefined,
): string {
  if (seconds == null || seconds <= 0) return '-';
  const total = Math.floor(seconds);
  const mm = Math.floor(total / 60);
  const ss = total % 60;
  return `${String(mm).padStart(2, '0')}:${String(ss).padStart(2, '0')}`;
}
